<template>
    <div id="about-us">
        <header-section/>
        <about-section/>
        <partner-section/>
        <team-section/>
        <career-section/>
        <schedule-demo-section class="pt-0"/>
        <custom-footer/>
    </div>
</template>

<script>
import AboutSection from '@/components/AboutSection.vue'
import CareerSection from '@/components/CareerSection.vue'
import CustomFooter from '@/components/Footer.vue'
import HeaderSection from '@/components/HeaderSection.vue'
import PartnerSection from '@/components/PartnerSection.vue'
import ScheduleDemoSection from '@/components/ScheduleDemoSection.vue'
import TeamSection from '@/components/TeamSection.vue'

export default {
    name: 'AboutUs',
    components: {
        AboutSection,
        CareerSection,
        PartnerSection,
        CustomFooter,
        HeaderSection,
        ScheduleDemoSection,
        TeamSection,
    },
}
</script>

<style lang='sass'>
@import 'sass/global.sass'

#about-us
    background-color: white
</style>
